var createQuizFrame = function() {
    var str = '<div class="modal-dialog" role="document">' +
        '<div class="modal-content">' +
        '<div class="modal-header">' +
        '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
        '<h4 class="modal-title" id="myModalLabel">Create Quiz</h4>' +
        '</div><!-- modal-header -->' +
        '<div class="modal-body">' +
        // JayG Jul 22, 2022 - #22450585 - Select which quiz to practice - Basic, Core, Applied
        '<div class="form-group">' +
        '<label for="select-exam">Select Exam Type</label>' +
        '<select class="form-control" id="select-exam">' +
        '<option value="">Select One</option>' +
        '<option value="Basic">Basic</option>' +
        '<option value="Core">Core</option>' +
        '<option value="Applied">Applied</option>' +
        '</select></div><!-- form-group -->' +
        // end JayG
        '<div class="form-group">' +
        '<label for="select-quiz">Select Quiz Type</label>' +
        '<select class="form-control" id="select-quiz">' +
        '<option value="">Select One</option>' +
        '<option value="25q">25 Random Questions</option>' +
        '<option value="25u">25 Unseen Questions</option>' +
        '<option value="50q">50 Random Questions</option>' +
        '<option value="50u">50 Unseen Questions</option>' +
        '<option value="custom">Custom</option>' +
        '</select></div>' +
        '<div class="form-group quiz-name-group" style="display:none">' +
        '<label for="quiz-name">Name</label>' +
        '<input type="text" name="name" id="quiz-name" class="form-control"/>' +
        '</div>' +
        '<div class="quiz-custom-settings" style="display:none">' +
        '<div class="form-group"><h3>Type of Questions:</h3>' +
        '<select name="question_type" id="question-type" class="form-control">' +
        '<option value="all">All Questions</option>' +
        '<option value="seen">Previously Seen</option>' +
        '<option value="unseen">Unseen</option>' +
        '<option value="correct">Correctly Answered</option>' +
        '<option value="incorrect">Incorrectly Answered</option>' +
        '<option value="skipped">Skipped</option>' +
        '<option value="guessed">Guessed</option>' +
        '</select>' +
        '<div class="settings-table-wrapper table-responsive"></div>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '<div class="modal-footer">' +
        '<div class="form-group"><button type="button" class="btn btn-default" id="create-quiz-button">Create and GO!</button></div>' +
        '</div>' +
        '</div><!-- modal-content -->' +
        '</div><!-- modal-dialog -->';
    return $.parseHTML(str);
}

module.exports = createQuizFrame;


//////////////////
// WEBPACK FOOTER
// ./src/create_quiz_frame.js
// module id = 302
// module chunks = 0